import { render, staticRenderFns } from "./ImportClaimBatch.vue?vue&type=template&id=7bb553ce"
import script from "./ImportClaimBatch.vue?vue&type=script&lang=js"
export * from "./ImportClaimBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports